var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./container.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?{\"id\":\"data-v-5ab812b0\"}!../../vue-loader/lib/selector?type=template&index=0!./container.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ci-components/components/container.vue
// module id = 241
// module chunks = 4